export default () => {

	function debounce(func, wait) {
		let timeout;
		return function(...args) {
			const context = this;
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(context, args), wait);
		};
	}


	function fitTextToViewport() {
		const elements = document.querySelectorAll('.js-fit-text');

		elements.forEach(element => {
			// Remove any inline font size setting to get the actual default size from CSS
			element.style.fontSize = "";

			// Reset font size to default to measure actual width
			const style = window.getComputedStyle(element);
			const defaultFontSize = style.fontSize;
			element.style.fontSize = defaultFontSize;

			let fontSize = parseInt(defaultFontSize, 10);

			// Decrease font size until the element fits within the viewport or until font size reaches a reasonable minimum limit
			while (element.offsetWidth > window.innerWidth && fontSize > 10) {
				fontSize--;
				element.style.fontSize = `${fontSize}px`;
			}
		});
	}

	// Initial adjustment
	fitTextToViewport();

	// Adjust on screen changes
	window.addEventListener('resize', debounce(fitTextToViewport, 200));
}